import React from "react"
import HorizontalField from "../HorizontalField/HorizontalField"
import {InterestTerms} from "../../resources/account"
import {InterestFormulaBox} from "../InterestFormulaBox/InterestFormulaBox"
import TierRowView from "./TierRowView"
import Disclaimer from "./Disclaimer"

interface InterestViewerProps {
	interestTerms: InterestTerms
	fedUpperBound?: number
	fedLowerBound?: number
}

function TieredInterestView({interestTerms, fedUpperBound, fedLowerBound}: InterestViewerProps) {
	const tiers = interestTerms.customerInterestTiers ?? []

	return (
		<>
			<HorizontalField label="Interest Mode" fieldClassName={"vertical-field"} useLabelTitle={true}>
				Tiered Interest
			</HorizontalField>

			<HorizontalField label="Calculation method" fieldClassName={"vertical-field"} useLabelTitle={true}>
				{interestTerms.customerInterestTieringMode ?? "Blended"}
			</HorizontalField>

			<div className="tier-section">
				{tiers.map((tier, index) => (
					<TierRowView
						key={index}
						tier={tier}
						index={index}
						fedUpperBound={fedUpperBound}
						fedLowerBound={fedLowerBound}
					/>
				))}
			</div>

			<Disclaimer />
		</>
	)
}

function NonTieredInterestView({interestTerms, fedUpperBound, fedLowerBound}: InterestViewerProps) {
	const isNonSplit = interestTerms.enableCustomerInterestFormula
	const formula = isNonSplit ? interestTerms.customerInterestFormula : interestTerms.interestFormula

	return (
		<>
			<HorizontalField label="Interest Mode" fieldClassName={"vertical-field"} useLabelTitle={true}>
				{isNonSplit ? "Non-Split" : "Proportional"}
			</HorizontalField>

			<HorizontalField label="Calculation formula" fieldClassName={"vertical-field"} useLabelTitle={true}>
				{formula && fedUpperBound !== undefined && fedLowerBound !== undefined ? (
					<InterestFormulaBox interestFormula={formula} fedUpperBound={fedUpperBound} fedLowerBound={fedLowerBound} />
				) : (
					formula
				)}
			</HorizontalField>

			{!isNonSplit && (
				<div className="interest-row-container">
					<HorizontalField label="Interest Rate" fieldClassName={"vertical-field"} useLabelTitle={true}>
						{interestTerms.interestRate}%
					</HorizontalField>

					<HorizontalField label="Customer Share" fieldClassName={"vertical-field"} useLabelTitle={true}>
						{interestTerms.customerInterestShare}%
					</HorizontalField>
				</div>
			)}

			<HorizontalField label="Customer Interest Rate" fieldClassName={"vertical-field"} useLabelTitle={true}>
				{interestTerms.customerInterestRate}%
			</HorizontalField>

			<Disclaimer />
		</>
	)
}

export default function InterestViewer({interestTerms, fedUpperBound, fedLowerBound}: InterestViewerProps) {
	const isTiered = interestTerms.enableTieredCustomerInterestFormula

	return (
		<div className="interest-viewer">
			{isTiered ? (
				<TieredInterestView interestTerms={interestTerms} fedUpperBound={fedUpperBound} fedLowerBound={fedLowerBound} />
			) : (
				<NonTieredInterestView
					interestTerms={interestTerms}
					fedUpperBound={fedUpperBound}
					fedLowerBound={fedLowerBound}
				/>
			)}
		</div>
	)
}
